import script from "./NewsPageBodyPost.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageBodyPost.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageBodyPost.vue?vue&type=style&index=0&id=1509cd84&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1509cd84"]])

export default __exports__